import { McoStaySuggestionPrediction } from '@/misc/types'

/**
 * i18n key for the model-type label ("IA classification" / "IA générative" / "IA agent")
 * of a predicted label, or null when there is no prediction at all.
 */
export function predictionModelTypeKey(prediction?: McoStaySuggestionPrediction | null): string | null {
  return prediction ? `prediction.modelType.${prediction.predictionModel.type}` : null
}

/**
 * Distinct model-type i18n keys across a set of predictions — one entry per
 * model type present (e.g. a code predicted by both a classification and a
 * generative model yields two keys). Used to render one source line per model.
 */
export function predictionModelTypeKeys(predictions?: McoStaySuggestionPrediction[] | null): string[] {
  const keys: string[] = []
  for (const prediction of predictions ?? []) {
    const key = predictionModelTypeKey(prediction)
    if (key && !keys.includes(key)) {
      keys.push(key)
    }
  }
  return keys
}
